module.exports = __webpack_public_path__ + "img/christmas-hero-2023-mobile.40effe10.jpg";